// Content data for Lempole website - both IT and EN

export const IMAGES = {
  // Hero: official Lempole rosé bottle on wood, warm terracotta backdrop (optimised WebP)
  hero: process.env.PUBLIC_URL + "/images/hero-desktop.webp",
  heroMobile: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/qv9bxrcq_Hero%20image%20-%20mobile.webp",
  // Radice — Madonnino: stone-wall terraces reclaimed by the forest
  root: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/bmap93ez_IMG_6323.webp",
  // Vigneron — Raffaello portrait with family in golden field (Nano Banana moderate face retouch, optimised WebP)
  vigneron: process.env.PUBLIC_URL + "/images/vigneron-retouched.webp",
  // Frutto — Lempole bottle indentation carved in the dried earth
  fruit: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/x59mmx03_Generated%20with%20Kive.ai%20-%20Bottle%20shaped%20indentation%20aggiungi%20l%27etichetta%20di%20Lempole.webp",
  // Breathe interlude — softer Lempole bottle on the wood/kive beauty shot
  breatheBottle: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/6vxqu2fr_Generated%20with%20Kive.ai%20-%20kive-image%20%2814%29.webp",
  // Manifesto — pink sloth mascot on the vine
  manifesto: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/em9l4iqr_lempole-sloth.png",
  // Rosato IGT — Lempole rosé bottle with pink shadow on white
  bottle: "https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/r7148kd2_Generated%20with%20Kive.ai%20-%20kive-image%20%2815%29.webp",
  // Sintonie — currently hidden, kept empty until partner logos are provided
  sintonie: []
};

export const CONTENT = {
  it: {
    nav: { lang1: 'IT', lang2: 'EN' },
    hero: {
      line1: '600 metri di quota.',
      line2: 'Terrazzamenti secolari.',
      line3: 'Un bradipo',
      body: 'Cosa fa un bradipo a Lamole? Scopri un progetto unico di viticoltura eroica, biodiversità e recupero che celebra l\u2019elogio della lentezza.',
      cta: 'Rallenta e scopri Lempole'
    },
    twoSouls: {
      overline: 'UN PROGETTO, DUE ANIME',
      exploreLabel: 'scorri per esplorare',
      root: {
        eyebrow: 'L\u2019ANIMA ROOT \u2014 La Radice',
        title: 'Madonnino dei Campacci',
        subtitle: 'Lamole, Chianti Classico.',
        body: 'È il cuore pulsante del progetto. Un atto di resistenza e bellezza che parte dal recupero dei terrazzamenti storici di Lamole, rimasti in silenzio per sessant\u2019anni. È l\u2019anima agronomica, il rispetto per la terra e la volontà di restituire dignità a un paesaggio antico. Qui la natura detta le regole e noi le ascoltiamo.'
      },
      bridge: {
        eyebrow: 'IL PONTE \u2014 il vigneron',
        title: 'Raffaello Tiezzi',
        subtitle: 'L\u2019Anello di Congiunzione',
        body: 'L\u2019esperienza di vent\u2019anni tra le vigne del mondo si fa mano artigiana. È la sua visione tecnica e umana a guidare il passaggio dalla terra alla bottiglia, garantendo che ogni gesto sia essenziale e necessario.',
        quote: '\u201CRaffaello è il ponte che trasforma il silenzio di Lamole nel sorso di Lempole\u201D'
      },
      pop: {
        eyebrow: 'L\u2019ANIMA POP \u2014 IL FRUTTO',
        title: 'Lempole',
        subtitle: 'L\u2019Elogio della Lentezza',
        body: 'Il primo frutto tangibile di questo cammino. Se Madonnino è la terra, Lempole è il lifestyle: un brand indipendente, fresco e contemporaneo. Il bradipo in etichetta non è solo un simbolo, ma il nostro manifesto: una Slow Wine Philosophy che sfida la fretta del mondo moderno per offrire un Sangiovese puro, vibrante e onesto.'
      }
    },
    manifesto: {
      overline: 'il nostro manifesto',
      title: 'L\u2019Elogio della Lentezza',
      lead: 'Il bradipo in etichetta è il nostro omaggio alla Slow Wine Philosophy, una filosofia che rispetta i tempi della natura e cura ogni vite come un pezzo unico. In un mondo che corre, Lempole si ferma a osservare la maturazione lenta del Sangiovese, intervenendo solo quando necessario, con il rispetto di chi sa che il vino si fa prima di tutto in vigna.',
      quote: '\u201CCome il bradipo, che resta immobile per ore aggrappato al suo ramo, anche noi abbiamo scelto di riprenderci il tempo.\u201D',
      close: '',
      cta: 'scopri il primo sorso'
    },
    bottle: {
      overline: 'la prima etichetta',
      title: 'ROSATO IGT TOSCANA',
      tagline: 'Pochi. Lenti. Numerati.',
      body: 'Il debutto di Lempole è un\u2019edizione limitatissima di sole 1.000 bottiglie. Abbiamo scelto il Sangiovese in purezza per raccontare la nostra terra, vestendolo di una freschezza insolita, luminosa, quasi provenzale. Vinificato esclusivamente in acciaio per preservare un\u2019energia vibrante, è un rosato contemporaneo, elegante e di estrema bevibilità. Al naso fragolina di bosco, lampone e pompelmo rosa; al palato sapido, con un\u2019acidità vivace.',
      badges: [
        { top: '1.000', bottom: 'bottiglie' },
        { top: 'bio', bottom: 'ad alta quota' },
        { top: 'sangiovese', bottom: 'in purezza' },
        { top: 'fresco', bottom: 'vivace' },
        { top: 'a mano', bottom: 'selezione' }
      ],
      cta: 'scheda tecnica'
    },
    quote: {
      body: 'Il vino buono ha bisogno di tempo, di silenzi e di mani che sappiano aspettare. In un mondo che corre, Lempole aspetta. Spero che questo sorso onesto, vibrante e soprattutto umano possa regalarvi un momento di meritata lentezza.',
      author: 'Raffaello'
    },
    diario: {
      overline: 'diario di lempole',
      title: 'Diario di Lempole',
      readMore: 'Annata 2025',
      backToSite: '\u2190 Torna al sito',
      annata: {
        kicker: 'Annata 2025',
        title: 'Note sull\u2019Annata 2025',
        intro: [
          'Questo diario non raccoglie solo dati tecnici, ma frammenti di tempo. \u00c8 il racconto di come la natura di Lamole, a 600 metri di quota, e la nostra filosofia della lentezza si sono incontrate nel corso di un anno straordinario.',
          'Qui non si corre. Si ascolta.'
        ],
        preview: 'Questo diario non raccoglie solo dati tecnici, ma frammenti di tempo. \u00c8 il racconto di come la natura di Lamole, a 600 metri di quota, e la nostra filosofia della lentezza si sono incontrate nel corso di un anno straordinario\u2026',
        entries: [
          {
            date: '15 Luglio 2025',
            title: 'Il Respiro dell\u2019Alta Quota',
            body: [
              'Mentre nella valle la morsa del caldo si fa sentire, qui al Madonnino i nostri terrazzamenti godono di una brezza costante. L\u2019inverno piovoso ha lasciato buone riserve idriche nel terreno profondo, ricco di scisto. Le viti sono in perfetto stato fitosanitario, la vegetazione \u00e8 rigogliosa ma equilibrata.',
              'Al momento dell\u2019allegagione (quando il fiore diventa frutto), i grappoli si presentano spargoli e sparsi. \u00c8 il preludio a una produzione contenuta, ma di grande concentrazione. Stiamo intervenendo manualmente per la gestione della chioma: un lavoro meticoloso per garantire che ogni grappolo riceva la giusta luce e aria. A Lamole, l\u2019agricoltura \u00e8 un dialogo costante, fatto di pazienza.'
            ]
          },
          {
            date: '15 Agosto 2025',
            title: 'L\u2019Invaiatura e la Magia delle Notti Lente',
            body: [
              'Un\u2019estate calda e luminosa, ma qui a Lamole \u00e8 la met\u00e0 di agosto a raccontare la vera unicit\u00e0 del terroir. Le giornate sono ancora piene di sole, ma le notti precipitano gi\u00e0 di temperatura. Questa escursione termica drastica (fino a 15\u00b0C di differenza) \u00e8 il nostro segreto pi\u00f9 prezioso.',
              'I chicchi di Sangiovese stanno completando l\u2019invaiatura (il cambio di colore), vestendosi di un rosso rubino profondo. Il freddo notturno rallenta la perdita di acidit\u00e0 e accumula precursori aromatici che daranno al nostro Rosato la freschezza vibrante e le note nitide di fragolina di bosco che cerchiamo. Il quadro tecnico sta gi\u00e0 dicendo che quest\u2019anna vogliamo un Rosato in stile provenzale, e per averlo dovremo anticipare.'
            ]
          },
          {
            date: '1 Settembre 2025',
            title: 'La Scelta del Rosato Provenzale',
            body: [
              'Le analisi delle uve di questa settimana ci danno l\u2019equilibrio perfetto per il vino che sogniamo: gradazione contenuta, acidit\u00e0 vibrante ancora integra, polifenoli bassi e croccanti. Sono i numeri esatti per un Rosato in stile provenzale \u2014 tesissimo, pallido, salato \u2014 quello che vogliamo Lempole sia.',
              'Aspettare di pi\u00f9 vorrebbe dire perdere questa grazia. In una zona dove tutti i vicini stanno pensando al rosso, noi facciamo la scelta opposta: anticipiamo. La vendemmia partir\u00e0 nei prossimi giorni, quando le uve sono ancora in punta di piedi. \u00c8 un atto di coraggio pi\u00f9 che di attesa: sappiamo che la finestra utile \u00e8 stretta, e vogliamo entrarci con la lucidit\u00e0 giusta.'
            ]
          },
          {
            date: '5\u20137 Settembre 2025',
            title: 'Mani Eroiche, Uve Integre',
            body: [
              '\u00c8 iniziata. La vendemmia Lempole \u00e8, per necessit\u00e0, un atto eroico e interamente manuale. Sulle pendenze dei terrazzamenti secolari, le mani dei nostri viticoltori si muovono con delicatezza millimetrica, prima che il sole si alzi davvero.',
              'Ogni grappolo viene selezionato in vigna. Solo le uve perfettamente integre, sane e mature al punto giusto per un Rosato entrano nelle piccole cassette da 15 kg. La resa \u00e8 bassissima, circa 40 quintali per ettaro, ma la qualit\u00e0 \u00e8 commovente. Le bucce sono spesse e croccanti, la polpa succosa e bilanciata. Le uve arrivano in cantina ancora fresche, grazie alle temperature mattutine dell\u2019alta quota, pronte per la pressatura soffice.'
            ]
          },
          {
            date: '5 Novembre 2025',
            title: 'Il Sorso Onesto della Lentezza',
            body: [
              'La fermentazione, avvenuta a temperatura controllata esclusivamente in acciaio per preservare la freschezza aromatica del Sangiovese di Lamole, \u00e8 conclusa.',
              'Oggi abbiamo effettuato il primo assaggio post-fermentativo dalla vasca. Il vino si presenta di un colore rosa buccia di cipolla, luminoso e brillante. Al naso \u00e8 gi\u00e0 un\u2019esplosione di floreale (violetta e iris) e fruttato fresco (fragolina, melograno), con una nota agrumata di pompelmo rosa molto netta. Al palato \u00e8 teso, sapido, con un\u2019acidit\u00e0 vibrante che verticalizza il sorso, ma sostenuto da una buona struttura tannica, fine ed elegante.',
              'Siamo felici. L\u2019annata 2025 ha confermato che Lamole, con le sue altezze e i suoi tempi lenti, \u00e8 il luogo ideale per un Sangiovese Rosato contemporaneo ed estremo. Ora, il vino riposer\u00e0 sulle sue fecce fini per tutto l\u2019inverno, maturando con calma la sua complessit\u00e0.'
            ]
          }
        ],
        closing: 'Il cammino continua.',
        signAs: 'Raffaello'
      },
      entries: [
        {
          season: 'inverno',
          month: 'gennaio',
          title: 'La potatura.',
          body: 'Forbici lente tra i tralci nudi. Ascoltiamo il legno per capire quale gemma sopravviverà alla nuova primavera.'
        },
        {
          season: 'primavera',
          month: 'aprile',
          title: 'I primi germogli.',
          body: 'La vigna si sveglia in silenzio. Le foglie tenere aprono il verso a un altro anno di attesa paziente.'
        },
        {
          season: 'estate',
          month: 'luglio',
          title: 'Il silenzio dei filari.',
          body: 'Cicale, calore, respiro sospeso. Camminiamo tra i terrazzamenti con la mano leggera del custode.'
        },
        {
          season: 'autunno',
          month: 'settembre',
          title: 'La vendemmia.',
          body: 'Grappoli scelti a mano, uno alla volta. La fretta non entra mai in cesta: entra solo la maturità giusta.'
        }
      ]
    },
    venues: {
      overline: 'la nostra famiglia',
      titleLead: 'Lempole vive già',
      titleItalic: 'sulle tavole giuste.',
      body: 'Da Firenze a Milano, fino a Tokyo. Da un bistrot di Lamole a una carta dei vini che sa aspettare, Lempole viene stappato là dove il tempo trova ancora spazio. Poche etichette, tanta cura, un rapporto diretto con chi ci sceglie.',
      inviteTitle: 'Porta nel tuo locale un progetto di viticoltura eroica, biodiversità e recupero.',
      inviteBody: 'Ristoranti, enoteche, wine bar, importatori esteri: chi porta Lempole nel proprio locale entra in una piccola comunità che condivide la nostra filosofia lenta. Se anche tu credi che il vino racconti un luogo, scrivici — ti risponderemo di persona.',
      ctaEmail: 'scrivici via email',
      ctaWhatsapp: 'scrivici su whatsapp',
      emailTo: 'ciao@lempole.wine',
      whatsappNumber: '+393289462581'
    },
    comingSlow: {
      overline: 'il prossimo capitolo',
      titleLead: 'Il cammino',
      titleItalic: 'è appena iniziato.',
      subtitle: 'Mentre ripristiniamo i terrazzamenti, il futuro si prepara con calma e la stessa, immutabile, promessa. Poche bottiglie, molta anima, nessuna fretta.',
      items: [
        { name: 'olio EVO', desc: 'Dall\u2019oliveto recuperato di Lamole.', year: 'attesa 2028', icon: 'olive' },
        { name: 'rosso',    desc: 'Il Sangiovese... al suo meglio.', year: 'attesa 2029', icon: 'glass' },
        { name: 'bolla',    desc: 'Le bolle più lente del Chianti, sospese sui lieviti per anni.', year: 'attesa 2031', icon: 'bubble' },
        { name: 'miele',    desc: 'La quintessenza della biodiversità di Lamole.', year: 'attesa 2027', icon: 'honey' }
      ],
      tag: 'coming slow',
      signedBy: 'Raffaello'
    },
    sintonie: {
      title: 'Sintonie.',
      body: 'Lempole si fa spazio nei calici delle tavole e dei luoghi iconici che hanno scelto di rallentare insieme a noi. Frammenti di un cammino comune.'
    },
    footer: {
      tagline: 'Un progetto di viticoltura eroica, biodiversità e recupero.',
      title: 'Lempole, dove il tempo si ferma.',
      handle: '@lempole.wine',
      copyright: '© 2026 Madonnino dei Campacci di Tiezzi Raffaello',
      address: 'Via Lamole 53, 50022 Greve in Chianti (FI)',
      vat: 'P.IVA 6836710480',
      rights: 'Tutti i diritti riservati.',
      cookie: 'Cookie policy',
      privacy: 'Privacy policy',
      terms: 'Termini e condizioni',
      email: 'madonninocampacci@gmail.com',
      phone: '+39 328 9462581',
      disclaimer1: 'Il vino è un piacere. Gustalo con lentezza e moderazione.',
      disclaimer2: 'Non bere se sei alla guida.',
      ageWarn: 'Vendita vietata ai minori di 18 anni.'
    }
  },
  en: {
    nav: { lang1: 'IT', lang2: 'EN' },
    hero: {
      line1: 'An elevation of 600 meters.',
      line2: 'Centuries-old terraces.',
      line3: 'A sloth',
      body: 'What is a sloth doing in Lamole? Discover a unique project of heroic viticulture, biodiversity, and restoration celebrating the praise of slowness.',
      cta: 'Slow down and discover Lempole'
    },
    twoSouls: {
      overline: 'ONE PROJECT, TWO SOULS',
      exploreLabel: 'scroll to explore',
      root: {
        eyebrow: 'THE ROOT SOUL \u2014 THE TERROIR',
        title: 'Madonnino dei Campacci',
        subtitle: 'Lamole, Chianti Classico.',
        body: 'It is the beating heart of the project. An act of resistance and beauty born from the restoration of Lamole\u2019s historic terraces, left in silence for sixty years. It represents our agronomic soul, a deep respect for the land, and the desire to restore dignity to an ancient landscape. Here, nature dictates the rules and we listen.'
      },
      bridge: {
        eyebrow: 'THE BRIDGE \u2014 THE VIGNERON',
        title: 'Raffaello Tiezzi',
        subtitle: 'The Connecting Link',
        body: 'Twenty years of experience among the world\u2019s vineyards transformed into an artisan\u2019s touch. It is his technical and human vision that guides the passage from the earth to the bottle, ensuring that every gesture is essential and necessary.',
        quote: '\u201CRaffaello is the bridge that transforms the silence of Lamole into the sip of Lempole.\u201D'
      },
      pop: {
        eyebrow: 'THE POP SOUL \u2014 THE FRUIT',
        title: 'Lempole',
        subtitle: 'In Praise of Slowness',
        body: 'The first tangible fruit of this journey. If Madonnino is the land, Lempole is the lifestyle: an independent, fresh, and contemporary brand. The sloth on the label is not merely a symbol, but our manifesto: a Slow Wine Philosophy that challenges the haste of the modern world to offer a pure, vibrant, and honest Sangiovese.'
      }
    },
    manifesto: {
      overline: 'OUR MANIFESTO',
      title: 'In Praise of Slowness',
      lead: 'The sloth on the label is our manifesto: it embodies the Slow Wine Philosophy, honouring nature\u2019s pace and tending to each vine as a unique creation. In a world that rushes, Lempole pauses to watch the slow ripening of Sangiovese, intervening only when necessary, with the respect of those who know that wine is made first and foremost in the vineyard.',
      quote: '\u201CLike the sloth that hangs motionless from its branch for hours, we too have chosen to take back our time.\u201D',
      close: '',
      cta: 'discover the first sip'
    },
    bottle: {
      overline: 'THE FIRST release',
      title: 'ROSATO IGT TOSCANA',
      tagline: 'Few. Slow. Numbered.',
      body: 'Lempole makes its debut with an extremely limited edition of just 1,000 bottles. We chose pure Sangiovese to tell the story of our land, dressing it in an unexpected, luminous, almost Provençal freshness. Vinified exclusively in stainless steel to preserve a vibrant energy, it is a contemporary rosé\u2014elegant and effortless to drink. Crisp on the nose with wild strawberry, raspberry, and pink grapefruit, and savory on the palate with a lively acidity.',
      badges: [
        { top: '1.000', bottom: 'bottles' },
        { top: 'organic', bottom: 'high altitude' },
        { top: 'sangiovese', bottom: '100%' },
        { top: 'fresh', bottom: 'vibrant' },
        { top: 'hand', bottom: 'selected' }
      ],
      cta: 'tech sheet'
    },
    quote: {
      body: 'Good wine takes time, silence, and hands that know how to wait. In a world that rushes, Lempole waits. I hope this honest, vibrant, and above all human sip brings you a moment of well-deserved slowness.',
      author: 'Raffaello'
    },
    diario: {
      overline: 'lempole diary',
      title: 'Lempole Diary',
      readMore: 'Vintage 2025',
      backToSite: '\u2190 Back to site',
      annata: {
        kicker: 'Vintage 2025',
        title: 'Notes on the 2025 Vintage',
        intro: [
          'This diary doesn\u2019t only gather technical data \u2014 it gathers fragments of time. It\u2019s the story of how Lamole\u2019s nature, at 600 metres of altitude, met our philosophy of slowness during an extraordinary year.',
          'Here nobody runs. Here we listen.'
        ],
        preview: 'Welcome to the heart of Madonnino dei Campacci. This diary gathers not only technical data but fragments of time \u2014 the story of how Lamole\u2019s nature, at 600 meters above sea level, met our philosophy of slowness during an extraordinary year\u2026',
        entries: [
          {
            date: '15 July 2025',
            title: 'The Breath of the High Altitude',
            body: [
              'While down in the valley the heat is starting to bite, up here at Madonnino our terraces enjoy a constant breeze. The rainy winter has left good water reserves deep in the schist-rich soil. The vines are in perfect health, the canopy lush yet balanced.',
              'At fruit-set (when the flower becomes a berry), the clusters come loose and scattered. It\u2019s the prelude to a modest crop \u2014 but one of great concentration. We\u2019re working the canopy by hand: meticulous work so every cluster gets the right dose of light and air. In Lamole, farming is a constant dialogue, made of patience.'
            ]
          },
          {
            date: '15 August 2025',
            title: 'V\u00e9raison and the Magic of Slow Nights',
            body: [
              'A hot, luminous summer \u2014 but here in Lamole it\u2019s mid-August that tells the real uniqueness of the terroir. The days are still full of sun, yet the nights already drop steeply in temperature. This drastic thermal excursion (up to 15\u00b0C) is our most precious secret.',
              'The Sangiovese berries are completing v\u00e9raison (the change of colour), dressing in a deep ruby red. The cool nights slow the loss of acidity and build aromatic precursors that will give our Rosato the vibrant freshness and the sharp notes of wild strawberry we\u2019re after. The technical picture is already saying that this year we want a Rosato in Proven\u00e7al style \u2014 and to have it we\u2019ll need to pick early.'
            ]
          },
          {
            date: '1 September 2025',
            title: 'The Choice of a Proven\u00e7al Rosé',
            body: [
              'This week\u2019s grape analyses give us the perfect balance for the wine we dream of: contained alcohol, vibrant acidity still intact, low and crunchy polyphenols. Those are exactly the numbers for a Rosato in Proven\u00e7al style \u2014 tense, pale, saline \u2014 which is what we want Lempole to be.',
              'Waiting longer would mean losing this grace. In an area where every neighbour is thinking about red, we choose the opposite path: we go early. Harvest will start in the next few days, when the grapes are still on tiptoe. It\u2019s an act of courage more than of waiting: we know the useful window is narrow, and we want to step into it with the right clarity.'
            ]
          },
          {
            date: '5\u20137 September 2025',
            title: 'Heroic Hands, Whole Berries',
            body: [
              'It has begun. The Lempole harvest is, of necessity, a heroic and fully manual act. On the slopes of the centuries-old terraces, the hands of our pickers move with millimetric care, before the sun has properly risen.',
              'Every cluster is chosen in the vineyard. Only perfectly whole, healthy grapes \u2014 ripe just right for a Rosato \u2014 go into the small 15 kg crates. Yield is very low, around 40 quintals per hectare, but the quality is moving. Skins are thick and crunchy, the flesh juicy and balanced. The grapes reach the cellar still cool, thanks to the morning temperatures of the high altitude, ready for a gentle press.'
            ]
          },
          {
            date: '5 November 2025',
            title: 'The Honest Sip of Slowness',
            body: [
              'Fermentation \u2014 at controlled temperature, exclusively in stainless steel to preserve the aromatic freshness of Lamole\u2019s Sangiovese \u2014 is complete.',
              'Today we tasted the wine from the tank for the first time after fermentation. It shows an onion-skin pink, luminous and bright. On the nose it\u2019s already an explosion of floral (violet and iris) and fresh fruit (wild strawberry, pomegranate), with a very clear note of pink grapefruit. On the palate it\u2019s taut, savoury, with a vibrant acidity that stretches the sip vertically, held up by good, fine, elegant tannin.',
              'We\u2019re happy. The 2025 vintage has confirmed that Lamole, with its altitudes and its slow times, is the ideal place for a contemporary, extreme Sangiovese Rosato. The wine will now rest on its fine lees through the winter, calmly maturing its complexity.'
            ]
          }
        ],
        closing: 'The journey continues.',
        signAs: 'Raffaello',
        onlyItalian: 'The full diary is available in Italian.'
      },
      entries: [
        {
          season: 'winter',
          month: 'january',
          title: 'Pruning.',
          body: 'Slow shears among bare canes. We listen to the wood to understand which bud will make it through the coming spring.'
        },
        {
          season: 'spring',
          month: 'april',
          title: 'The first buds.',
          body: 'The vineyard wakes in silence. Tender leaves open the verse of another year of patient waiting.'
        },
        {
          season: 'summer',
          month: 'july',
          title: 'The silence of the rows.',
          body: 'Cicadas, warmth, suspended breath. We walk the terraces with the light hand of a caretaker.'
        },
        {
          season: 'autumn',
          month: 'september',
          title: 'The harvest.',
          body: 'Clusters chosen by hand, one at a time. Haste never enters the basket \u2014 only the right ripeness does.'
        }
      ]
    },
    venues: {
      overline: 'our extended family',
      titleLead: 'Lempole already lives',
      titleItalic: 'on the right tables.',
      body: 'From Florence to Milan, all the way to Tokyo. From a bistro in Lamole to a wine list that knows how to wait, Lempole is uncorked where time still has room to breathe. A handful of labels, deep care, and a direct bond with those who choose us.',
      inviteTitle: 'Bring a project of heroic viticulture, biodiversity and recovery into your venue.',
      inviteBody: 'Restaurants, wine shops, wine bars, international importers: those who bring Lempole to their venue join a small community that shares our slow philosophy. If you believe wine should tell the story of a place, write to us and we will reply in person.',
      ctaEmail: 'write to us by email',
      ctaWhatsapp: 'message us on whatsapp',
      emailTo: 'ciao@lempole.wine',
      whatsappNumber: '+393289462581'
    },
    comingSlow: {
      overline: 'the next chapter',
      titleLead: 'The journey',
      titleItalic: 'has just begun.',
      subtitle: 'As we restore the stone terraces, the future takes shape with quiet calm and the very same, unyielding promise: few bottles, rich soul, no rush.',
      items: [
        { name: 'olio EVO', desc: 'From the rediscovered olive grove of Lamole.', year: 'awaited 2028', icon: 'olive' },
        { name: 'rosso',    desc: 'The Sangiovese that takes its time. It will arrive when it is ready.', year: 'awaited 2029', icon: 'glass' },
        { name: 'bolla',    desc: 'Traditional Method: the slowest bubbles in Chianti.', year: 'awaited 2031', icon: 'bubble' },
        { name: 'miele',    desc: 'The quintessence of Lamole\u2019s biodiversity. A pure nectar born from high-altitude flora.', year: 'awaited 2027', icon: 'honey' }
      ],
      tag: 'coming slow',
      signedBy: 'Raffaello'
    },
    sintonie: {
      title: 'Harmonies.',
      body: 'From the land of Lamole to the tables of venues and projects that share our very same idea of time.'
    },
    footer: {
      tagline: 'A project of heroic viticulture, biodiversity, and restoration.',
      title: 'Lempole, where time stands still.',
      handle: '@lempole.wine',
      copyright: '© 2026 Madonnino dei Campacci di Tiezzi Raffaello',
      address: 'Via Lamole 53, 50022 Greve in Chianti (FI)',
      vat: 'VAT 6836710480',
      rights: 'All rights reserved.',
      cookie: 'Cookie policy',
      privacy: 'Privacy policy',
      terms: 'Terms & conditions',
      email: 'madonninocampacci@gmail.com',
      phone: '+39 328 9462581',
      disclaimer1: 'Wine is a pleasure. Enjoy it slowly, with moderation.',
      disclaimer2: 'Please do not drink and drive.',
      ageWarn: 'Sale forbidden to persons under 18.'
    }
  },
  fr: {
    nav: { lang1: 'IT', lang2: 'EN' },
    hero: {
      line1: '600 mètres d\u2019altitude.',
      line2: 'Terrasses séculaires.',
      line3: 'Un paresseux',
      body: 'Que fait un paresseux à Lamole ? Découvrez un projet unique de viticulture héroïque, de biodiversité et de reconquête qui célèbre l\u2019éloge de la lenteur.',
      cta: 'Ralentissez et découvrez Lempole'
    },
    twoSouls: {
      overline: 'UN PROJET, DEUX ÂMES',
      exploreLabel: 'faites défiler pour explorer',
      root: {
        eyebrow: 'L\u2019ÂME ROOT \u2014 LA RACINE',
        title: 'Madonnino dei Campacci',
        subtitle: 'Lamole, Chianti Classico.',
        body: 'C\u2019est le cœur battant du projet. Un acte de résistance et de beauté qui part de la reconquête des terrasses historiques de Lamole, restées silencieuses pendant soixante ans. C\u2019est l\u2019âme agronomique, le respect de la terre et la volonté de rendre sa dignité à un paysage ancien. Ici la nature dicte les règles et nous les écoutons.'
      },
      bridge: {
        eyebrow: 'LE PONT \u2014 LE VIGNERON',
        title: 'Raffaello Tiezzi',
        subtitle: 'Le Maillon',
        body: 'Vingt ans d\u2019expérience dans les vignes du monde se transforment en main artisanale. C\u2019est sa vision technique et humaine qui guide le passage de la terre à la bouteille, en veillant à ce que chaque geste soit essentiel et nécessaire.',
        quote: '\u201CRaffaello est le pont qui transforme le silence de Lamole en la gorgée de Lempole.\u201D'
      },
      pop: {
        eyebrow: 'L\u2019ÂME POP \u2014 LE FRUIT',
        title: 'Lempole',
        subtitle: 'L\u2019Éloge de la Lenteur',
        body: 'Le premier fruit tangible de ce cheminement. Si Madonnino est la terre, Lempole est le style de vie : une marque indépendante, fraîche et contemporaine. Le paresseux sur l\u2019étiquette n\u2019est pas qu\u2019un symbole : c\u2019est notre manifeste. Une Slow Wine Philosophy qui défie la hâte du monde moderne pour offrir un Sangiovese pur, vibrant et honnête.'
      }
    },
    manifesto: {
      overline: 'notre manifeste',
      title: 'L\u2019Éloge de la Lenteur',
      lead: 'Le paresseux sur l\u2019étiquette est notre hommage à la Slow Wine Philosophy, une philosophie qui respecte le rythme de la nature et prend soin de chaque cep comme d\u2019une pièce unique. Dans un monde qui court, Lempole s\u2019arrête pour observer la maturation lente du Sangiovese, n\u2019intervenant que quand c\u2019est nécessaire, avec le respect de ceux qui savent que le vin se fait d\u2019abord à la vigne.',
      quote: '\u201CComme le paresseux, qui reste immobile pendant des heures accroché à sa branche, nous aussi avons choisi de reprendre notre temps.\u201D',
      close: '',
      cta: 'découvrir la première gorgée'
    },
    bottle: {
      overline: 'la première étiquette',
      title: 'ROSATO IGT TOSCANA',
      tagline: 'Peu. Lents. Numérotés.',
      body: 'Le début de Lempole est une édition très limitée de seulement 1 000 bouteilles. Nous avons choisi le Sangiovese en pureté pour raconter notre terre, en l\u2019habillant d\u2019une fraîcheur inhabituelle, lumineuse, presque provençale. Vinifié exclusivement en inox pour préserver une énergie vibrante, c\u2019est un rosé contemporain, élégant et d\u2019une buvabilité extrême. Au nez, fraise des bois, framboise et pamplemousse rose ; en bouche, salin, avec une acidité vive.',
      badges: [
        { top: '1.000', bottom: 'bouteilles' },
        { top: 'bio', bottom: 'haute altitude' },
        { top: 'sangiovese', bottom: 'en pureté' },
        { top: 'frais', bottom: 'vif' },
        { top: 'à la main', bottom: 'sélection' }
      ],
      cta: 'fiche technique'
    },
    quote: {
      body: 'Le bon vin a besoin de temps, de silences et de mains qui savent attendre. Dans un monde qui court, Lempole attend. J\u2019espère que cette gorgée honnête, vibrante et surtout humaine pourra vous offrir un moment de lenteur bien méritée.',
      author: 'Raffaello'
    },
    diario: {
      overline: 'journal de lempole',
      title: 'Journal de Lempole',
      readMore: 'Millésime 2025',
      backToSite: '\u2190 Retour au site',
      annata: {
        kicker: 'Millésime 2025',
        title: 'Notes sur le Millésime 2025',
        intro: [
          'Ce journal ne rassemble pas seulement des données techniques \u2014 il rassemble des fragments de temps. C\u2019est le récit de la rencontre, au fil d\u2019une année extraordinaire, entre la nature de Lamole, à 600 mètres d\u2019altitude, et notre philosophie de la lenteur.',
          'Ici on ne court pas. Ici on écoute.'
        ],
        preview: 'Bienvenue au cœur de Madonnino dei Campacci. Ce journal ne rassemble pas seulement des données techniques mais des fragments de temps \u2014 le récit de la rencontre entre la nature de Lamole, à 600 mètres, et notre philosophie de la lenteur au fil d\u2019une année extraordinaire\u2026',
        entries: [
          {
            date: '15 juillet 2025',
            title: 'Le Souffle de la Haute Altitude',
            body: [
              'Alors que dans la vallée la chaleur commence à mordre, ici, au Madonnino, nos terrasses profitent d\u2019une brise constante. L\u2019hiver pluvieux a laissé de bonnes réserves d\u2019eau en profondeur, dans un sol riche en schistes. Les vignes sont en parfaite santé, la végétation est luxuriante mais équilibrée.',
              'À la nouaison (quand la fleur devient baie), les grappes se présentent lâches et éparses. C\u2019est le prélude à une production modeste, mais d\u2019une grande concentration. Nous intervenons à la main pour la gestion de la canopée : un travail minutieux pour que chaque grappe reçoive la juste dose de lumière et d\u2019air. À Lamole, l\u2019agriculture est un dialogue constant, fait de patience.'
            ]
          },
          {
            date: '15 août 2025',
            title: 'La Véraison et la Magie des Nuits Lentes',
            body: [
              'Un été chaud et lumineux — mais ici à Lamole c\u2019est la mi-août qui raconte la vraie singularité du terroir. Les journées sont encore pleines de soleil, mais les nuits chutent déjà en température. Cet écart thermique drastique (jusqu\u2019à 15 °C) est notre secret le plus précieux.',
              'Les baies de Sangiovese achèvent leur véraison (le changement de couleur), s\u2019habillant d\u2019un rouge rubis profond. Le froid nocturne ralentit la perte d\u2019acidité et accumule des précurseurs aromatiques qui donneront à notre rosé la fraîcheur vibrante et les notes nettes de fraise des bois que nous recherchons. Le tableau technique dit déjà que cette année nous voulons un rosé de style provençal — et pour l\u2019avoir, il faudra anticiper.'
            ]
          },
          {
            date: '1er septembre 2025',
            title: 'Le Choix du Rosé Provençal',
            body: [
              'Les analyses des raisins de cette semaine nous donnent l\u2019équilibre parfait pour le vin dont nous rêvons : degré contenu, acidité vibrante encore intacte, polyphénols bas et croquants. Ce sont exactement les chiffres d\u2019un rosé de style provençal — tendu, pâle, salin — celui que nous voulons que Lempole soit.',
              'Attendre plus, ce serait perdre cette grâce. Dans une zone où tous les voisins pensent au rouge, nous faisons le choix inverse : nous anticipons. La vendange commencera dans les prochains jours, quand les raisins sont encore sur la pointe des pieds. C\u2019est un acte de courage plus que d\u2019attente : nous savons que la fenêtre utile est étroite, et nous voulons y entrer avec la bonne lucidité.'
            ]
          },
          {
            date: '5–7 septembre 2025',
            title: 'Mains Héroïques, Baies Intactes',
            body: [
              'C\u2019est parti. La vendange de Lempole est, par nécessité, un acte héroïque et entièrement manuel. Sur les pentes des terrasses séculaires, les mains de nos vendangeurs se meuvent avec une délicatesse millimétrique, avant que le soleil ne se lève vraiment.',
              'Chaque grappe est choisie à la vigne. Seuls les raisins parfaitement intacts, sains et mûrs juste comme il faut pour un rosé entrent dans les petites cagettes de 15 kg. Le rendement est très bas, environ 40 quintaux par hectare, mais la qualité est bouleversante. Les peaux sont épaisses et croquantes, la pulpe juteuse et équilibrée. Les raisins arrivent en cave encore frais, grâce aux températures matinales de la haute altitude, prêts pour un pressurage doux.'
            ]
          },
          {
            date: '5 novembre 2025',
            title: 'La Gorgée Honnête de la Lenteur',
            body: [
              'La fermentation — à température contrôlée, exclusivement en inox pour préserver la fraîcheur aromatique du Sangiovese de Lamole — est terminée.',
              'Aujourd\u2019hui nous avons dégusté pour la première fois le vin en cuve après fermentation. Il se présente d\u2019un rose pelure d\u2019oignon, lumineux et brillant. Au nez c\u2019est déjà une explosion florale (violette et iris) et de fruit frais (fraise des bois, grenade), avec une note très nette de pamplemousse rose. En bouche il est tendu, salin, avec une acidité vibrante qui verticalise la gorgée, soutenue par un tanin bon, fin et élégant.',
              'Nous sommes heureux. Le millésime 2025 a confirmé que Lamole, avec ses altitudes et ses temps lents, est le lieu idéal pour un Sangiovese rosé contemporain et extrême. Le vin reposera à présent sur ses lies fines tout l\u2019hiver, mûrissant sa complexité avec calme.'
            ]
          }
        ],
        closing: 'Le chemin continue.',
        signAs: 'Raffaello',
        onlyItalian: 'Le journal complet est disponible en italien.'
      },
      entries: [
        {
          season: 'hiver',
          month: 'janvier',
          title: 'La taille.',
          body: 'Sécateurs lents entre les sarments nus. Nous écoutons le bois pour comprendre quel bourgeon survivra au nouveau printemps.'
        },
        {
          season: 'printemps',
          month: 'avril',
          title: 'Les premiers bourgeons.',
          body: 'La vigne se réveille en silence. Les feuilles tendres ouvrent le vers d\u2019une nouvelle année d\u2019attente patiente.'
        },
        {
          season: 'été',
          month: 'juillet',
          title: 'Le silence des rangs.',
          body: 'Cigales, chaleur, souffle suspendu. Nous marchons entre les terrasses avec la main légère du gardien.'
        },
        {
          season: 'automne',
          month: 'septembre',
          title: 'La vendange.',
          body: 'Grappes choisies à la main, une à une. La hâte n\u2019entre jamais dans la corbeille : seule la juste maturité y entre.'
        }
      ]
    },
    venues: {
      overline: 'notre famille',
      titleLead: 'Lempole vit déjà',
      titleItalic: 'sur les bonnes tables.',
      body: 'De Florence à Milan, jusqu\u2019à Tokyo. D\u2019un bistrot de Lamole à une carte des vins qui sait attendre, Lempole se débouche là où le temps trouve encore de la place. Peu d\u2019étiquettes, beaucoup de soin, une relation directe avec celles et ceux qui nous choisissent.',
      inviteTitle: 'Amenez dans votre établissement un projet de viticulture héroïque, de biodiversité et de reconquête.',
      inviteBody: 'Restaurants, cavistes, wine bars, importateurs étrangers : ceux qui accueillent Lempole entrent dans une petite communauté qui partage notre philosophie lente. Si vous aussi vous croyez que le vin raconte un lieu, écrivez-nous — nous vous répondrons en personne.',
      ctaEmail: 'écrivez-nous par email',
      ctaWhatsapp: 'écrivez-nous sur WhatsApp',
      emailTo: 'ciao@lempole.wine',
      whatsappNumber: '+393289462581'
    },
    comingSlow: {
      overline: 'le prochain chapitre',
      titleLead: 'Le chemin',
      titleItalic: 'ne fait que commencer.',
      subtitle: 'Pendant que nous remettons en état les terrasses, l\u2019avenir se prépare avec calme et la même promesse immuable. Peu de bouteilles, beaucoup d\u2019âme, aucune hâte.',
      items: [
        { name: 'huile d\u2019olive extra vierge', desc: 'De l\u2019oliveraie retrouvée de Lamole.', year: 'attendu 2028', icon: 'olive' },
        { name: 'rouge',    desc: 'Le Sangiovese… à son sommet.', year: 'attendu 2029', icon: 'glass' },
        { name: 'bulle',    desc: 'Les bulles les plus lentes du Chianti, suspendues sur les lies pendant des années.', year: 'attendu 2031', icon: 'bubble' },
        { name: 'miel',     desc: 'La quintessence de la biodiversité de Lamole.', year: 'attendu 2027', icon: 'honey' }
      ],
      tag: 'coming slow',
      signedBy: 'Raffaello'
    },
    sintonie: {
      title: 'Résonances.',
      body: 'De la terre de Lamole aux tables des lieux et des projets qui partagent la même idée du temps.'
    },
    footer: {
      tagline: 'Un projet de viticulture héroïque, de biodiversité et de reconquête.',
      title: 'Lempole, là où le temps s\u2019arrête.',
      handle: '@lempole.wine',
      copyright: '© 2026 Madonnino dei Campacci di Tiezzi Raffaello',
      address: 'Via Lamole 53, 50022 Greve in Chianti (FI)',
      vat: 'TVA 6836710480',
      rights: 'Tous droits réservés.',
      cookie: 'Cookie policy',
      privacy: 'Privacy policy',
      terms: 'Conditions générales',
      email: 'madonninocampacci@gmail.com',
      phone: '+39 328 9462581',
      disclaimer1: 'Le vin est un plaisir. Dégustez-le lentement, avec modération.',
      disclaimer2: 'L\u2019abus d\u2019alcool est dangereux pour la santé. Ne conduisez pas si vous avez bu.',
      ageWarn: 'Vente interdite aux mineurs de moins de 18 ans.'
    }
  }
};

export const TECH_SHEET_URL = '/schede/lempole-rosato-it.pdf';
export const TECH_SHEETS = {
  it: '/schede/lempole-rosato-it.pdf',
  en: '/schede/lempole-rosato-en.pdf',
  fr: '/schede/lempole-rosato-fr.pdf',
};
export const INSTAGRAM_URL = 'https://instagram.com/lempole.wine';
